import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styled, { createGlobalStyle  } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    table {
      td {
        background: #f6f8fa;
      }
    }
    .loading_layer {
      background: none;
    }
    .spinner {
      top: 30% !important;
    }
  }
`

const Context = styled.div`
  place-content: center;
  align-items: center;
  height: 100%;
  display: flex;
  #tabular td {
    background: #f6f8fa;
  }
`;

function MathpixView() {
  const location = useLocation();

  useEffect(() => {

    const { search } = location;
    const latex = decodeURI(search).replace('?latex=', '');

console.log({ latex, location });

    const script = document.createElement('script');
    script.src = "https://fastly.jsdelivr.net/npm/mathpix-markdown-it@1.0.40/es5/bundle.js";
    script.async = true;
    document.head.append(script);
    script.onload = function () {
      const isLoaded = window.loadMathJax();
      const output = document.getElementById('content');
      if (isLoaded) {
        const options = {
          htmlTags: true
        };
        let t = window.markdownToHTML(atob(latex), options)
        if (output) output.innerHTML = t;
      };
    }
  });

  useEffect(() => {
    const dom = document.getElementsByClassName('v-pc')[0];
    if (dom) {
      dom.className = "";
      dom.style.height = '100%';
    };
  });

  return (
    <React.Fragment>
      <GlobalStyle />
      <Context
        className="content"
        id="content"
        // dangerouslySetInnerHTML={{ __html: `3 \times 3` }}
      />
    </React.Fragment>
  );
}

export default MathpixView;